import React from 'react';

const steps = [
  {
    title: 'Colle ton lien Sora',
    text: 'Copie simplement l’URL de ta vidéo Sora directement dans Muzo Studio.',
  },
  {
    title: 'On récupère la vidéo sans watermark',
    text: 'Tu as droit à 1 téléchargement gratuit par jour sur le plan gratuit.',
  },
  {
    title: 'Passe-la en 1440p ultra clean',
    text: 'Choisis l\'upscale ×2, on te renvoie la version 1440p prête à publier.',
  },
  {
    title: 'Publie partout',
    text: 'TikTok, Shorts, Reels… ta vidéo est prête pour tous les formats.',
  },
];

const OnboardingTips = ({ onStart }) => (
  <section className="rounded-3xl border border-dashed border-slate-300 dark:border-white/20 bg-white/70 dark:bg-slate-900/40 p-5 shadow-inner flex flex-col gap-4">
    <div>
      <p className="text-sm uppercase tracking-wide text-slate-500 dark:text-slate-300">
        Nouveau sur Muzo ?
      </p>
      <h2 className="text-xl font-semibold">Comment ça marche ?</h2>
    </div>
    <ol className="space-y-3 text-sm text-slate-600 dark:text-slate-300">
      {steps.map((step, index) => (
        <li key={step.title} className="flex gap-3">
          <span className="text-indigo-600 dark:text-indigo-300 font-semibold">{index + 1}.</span>
          <div>
            <p className="font-semibold">{step.title}</p>
            <p>{step.text}</p>
          </div>
        </li>
      ))}
    </ol>
    <button
      type="button"
      onClick={onStart}
      className="self-start px-4 py-2 rounded-xl bg-indigo-600 text-white text-sm font-semibold hover:bg-indigo-500"
    >
      Commencer avec ma première vidéo
    </button>
  </section>
);

export default OnboardingTips;
